<template >
  <div class="modifyDialog">
    <el-dialog title="组合开通" :visible.sync="dialogVisible" width="600px">
      <el-form ref="zuheForm" :model="zuheForm" :rules="rules" label-width="140px">
        <el-form-item label="组合名称"  class="is-required" prop="maxInvokeName">
          <el-input v-model="zuheForm.maxInvokeName" ></el-input>
        </el-form-item>
        <el-form-item label="每日接口调用上限"  class="is-required" prop="maxInvokePerDay">
          <el-input v-model.number="zuheForm.maxInvokePerDay" ></el-input>
        </el-form-item>
        <el-form-item label="每日去重下载上限"  class="is-required" prop="maxDownloadPerDay">
          <el-input  v-model.number="zuheForm.maxDownloadPerDay"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">关闭</el-button>
        <el-button type="primary" @click="doit()" v-loading="loading">提交</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script type="text/babel">

import devService from '../../../../service/devService'
import { mapGetters } from 'vuex'

export default {
  props: {
    rowData: {
      type: Object
    },
    value: {
      type: Boolean,
      default () {
        return false
      }
    }
  },
  data () {
    return {
      loading: false,
      zuheForm: {
        maxInvokeName: '',
        maxInvokePerDay: '',
        maxDownloadPerDay: ''
      },
      rules: {
        maxInvokeName: [
          { required: true, message: '请输入组合名称', trigger: ['blur', 'change'] }
        ],
        maxInvokePerDay: [
          { type: 'number', required: true, message: '请输入每日接口调用上限数', trigger: ['blur', 'change'] }
        ],
        maxDownloadPerDay: [
          { type: 'number', required: true, message: '请输入每日调用上限数', trigger: ['blur', 'change'] }
        ]
      }
    }
  },
  methods: {
    doit () {
      this.loading = true
      this.$refs['zuheForm'].validate(async valid => {
        // 验证通过
        if (valid) {
          try {
            let params = {
              ...this.zuheForm,
              name: this.zuheForm.maxInvokeName,
              userId: this.companyInfo.id
            }
            await devService.setZuheOpen(params)
            // 重置表单
            this.$refs.zuheForm.resetFields()
            // 保存对象
            this.$emit('success')
            this.loading = false
            this.dialogVisible = false
          } catch (e) {
            this.$message.error(e && e.msg)
            this.loading = false
          }
        }
        this.loading = false
      })
    }
  },
  watch: {
    dialogVisible (newVal, oldVal) {
      if (newVal) {
        if (this.$refs.zuheForm) {
          this.$refs.zuheForm.resetFields()
        }
        this.zuheForm = {}
        if (!this.$props.rowData.maxInvokeName) {
          return
        }
        this.zuheForm = {
          maxInvokeName: this.$props.rowData.maxInvokeName,
          maxInvokePerDay: this.$props.rowData.maxInvokePerDay,
          maxDownloadPerDay: this.$props.rowData.maxDownloadPerDay
        }
      }
    }
  },
  computed: {
    ...mapGetters(['companyInfo']),
    dialogVisible: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  }
}
</script>
<style scoped>

</style>
<style type="text/css">

</style>



// WEBPACK FOOTER //
// src/pages/admin/interface-manage/zuhe-dialog/index.vue